export function createContentParagraph(block, parent) {
    const blockName = block.data_block_name;

    const wrapper = document.createElement('div');
    wrapper.className = 'content-paragraph-block';
    wrapper.setAttribute('data-block-name', blockName);
    wrapper.setAttribute('data-block-id', block.id || '');
    wrapper.setAttribute('data-order', String(block.order ?? 0));
    if (block.page_id) {
        wrapper.setAttribute('data-page-id', String(block.page_id));
    }

    wrapper.innerHTML = `
        <div class="content-row">
            <div class="content-row__label">
                <p class="content-label" data-content="${blockName}-label" data-global="false"></p>
            </div>
            <div class="content-row__body">
                <p data-content="${blockName}-text" data-type="textarea" data-attribute="html" data-global="false"></p>
            </div>
        </div>
    `;

    parent.appendChild(wrapper);
    return wrapper;
}

export const contentParagraphProps = {
    name: 'content-paragraph',
    title: 'Параграф',
    description: 'Рядок з міткою ліворуч і текстом праворуч',
    allowedParents: ['news-content', 'diagnostic-content'],
    requiresPage: true,
    contentFields: [
        { name: 'label', type: 'text', label: 'Мітка (ліворуч)' },
        { name: 'text', type: 'textarea', label: 'Текст (праворуч)' }
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview content-paragraph-preview" style="display:flex;gap:10px;">
                <span style="flex:0 0 50%;font-size:11px;opacity:0.5;">${data.label || 'Мітка...'}</span>
                <p style="flex:1;margin:0;">${data.text || 'Текст параграфа...'}</p>
            </div>
        `;
    }
};
